export default __webpack_public_path__ + "static/media/toggle-background-chords.5f294a25.svg";